if (!customElements.get('inira-timeline')) {
  customElements.define('inira-timeline', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const cards = [...this.querySelectorAll('article')];
      const select = (card) => cards.forEach(item => {
        const active = item === card;
        item.classList.toggle('is-active', active);
        item.querySelector('button').setAttribute('aria-pressed', String(active));
      });
      cards.forEach(card => {
        card.addEventListener('click', () => select(card), options);
      });
      if (!cards.some(card => card.classList.contains('is-active')) && cards[0]) select(cards[0]);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
